import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import QuestionForm from './QuestionForm'

import { storeQuestion } from '../services'
import { handleError } from '../../../helpers'

export default function NewQuestionModal({ visible, onClose, reload, survey }) {
	const { register, handleSubmit, formState: { errors } } = useForm({
		defaultValues: {
			survey_id: survey.id
		}
	})

	const onSubmit = values => {
		storeQuestion(values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Agregar Registro</ModalHeader>
				<ModalBody>
					<Form onSubmit={handleSubmit(onSubmit)}>
						<QuestionForm register={register} errors={errors} />
						<Button color="primary" type="submit">Agregar Registro</Button>
					</Form>
				</ModalBody>
			</Modal>
		</React.Fragment>
	)
}